import { ArrowRightIcon } from "../assets/icons/index.js";

export default function Button({
  children,
  onClick,
  withArrow = false,
  icon = null,
  selected = false,
  className,
}) {
  return (
    <button
      onClick={onClick}
      className={`group ${
        selected
          ? "bg-lz-ink-mid border-lz-ink-mid text-white dark:bg-lz-candle-dim dark:border-lz-candle-dim dark:text-lz-concrete"
          : "bg-lz-ember text-white border-lz-ember hover:bg-lz-ink-mid hover:border-lz-ink-mid dark:hover:bg-lz-candle-dim dark:hover:border-lz-candle-dim dark:hover:text-lz-concrete"
      } border rounded-lg px-4 py-2 flex items-center gap-x-3 font-semibold transition-colors ${className}`}
    >
      {icon && (
        <div className={`w-5 h-5 ${
          selected
            ? "fill-white dark:fill-lz-concrete"
            : "fill-white dark:group-hover:fill-lz-concrete"
        } transition-colors`}>
          {icon}
        </div>
      )}
      {children}
      {withArrow && (
        <ArrowRightIcon className={`w-5 h-5 ${
          selected
            ? "fill-white dark:fill-lz-concrete"
            : "fill-white dark:group-hover:fill-lz-concrete"
        } transition-colors`} />
      )}
    </button>
  );
}
